import { Typography } from '@mui/material';
import React from 'react';

interface TestimonialCardProps {
  quote: string;
  name: string;
  imageUrl?: string;
  platform?: string;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  quote,
  name,
  imageUrl = '',
  platform = '',
}) => {
  const platformIcons: Record<string, string> = {
    instagram: '/assets/images/homepage/social/instagram.svg',
    facebook: '/assets/images/homepage/social/facebook.svg',
    tiktok: '/assets/images/homepage/social/tiktok.svg',
  };

  const platformIcon = platformIcons[platform.toLowerCase()] || '';

  return (
    <div className="min-h-[200px] w-full sm:max-w-[300px] md:w-1/2 lg:w-[300px] rounded-3xl p-8 md:px-4 bg-paper md:text-center space-y-8 md:space-y-10 flex flex-col justify-between">
      <Typography variant="body-500" component="p">
        {quote}
      </Typography>

      <div className="flex md:flex-col items-center gap-4 md:gap-2">
        <div
          className="size-10 md:size-[116px] bg-cover bg-center rounded-full overflow-hidden bg-primary-main"
          style={{ backgroundImage: `url(${imageUrl})` }}
        />
        <div className="flex flex-col md:items-center text-center">
          <Typography variant="body-500" color="textPrimary" component="p">
            {name}
          </Typography>

          {platform && platformIcon && (
            <div className="flex gap-x-2 items-center">
              <img src={platformIcon} className="size-4" alt={`${platform} icon`} />
              <Typography variant="body-small-500" color="textSecondary">
                {platform}
              </Typography>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
